import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Col, Row, Divider, DatePicker, Select } from 'antd';
import BaseSelect from '@/components/Elements/BaseSelect';
import BaseRadios from '@/components/Elements/BaseRadios';
import generatePassword from 'generate-password';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import { _newLine, toMoment } from '@/utils/helpers';
import { createUser, updateUser } from '@/redux/actions/userActions';
import ImageSelector from '@/components/ImageSelector';

const { RangePicker } = DatePicker;

class UserForm extends Component {
    state = {
        loading: false,
        userRole: null,
        avatars: [],
        diplomas: [],
        identity_documents: [],
        certificates: [],
        other_documents: [],
    }

    componentDidUpdate(prevProps) {

        // Khi mở form update
        if (this.props.user && this.props.user !== prevProps.user) {
            this.setState({
                avatars: this.props.user.avatar || [],
                diplomas: this.props.user.diploma_file || [],
                identity_documents: this.props.user.identity_document_file || [],
                certificates: this.props.user.certificate_file || [],
                other_documents: this.props.user.other_documents || [],
            });
        }

        // Khi đóng modal
        if (!this.props.visible && prevProps.visible) {
            this.resetUploadState();
        }
    }

    resetUploadState = () => {
        this.setState({
            loading: false,
            avatars: [],
            diplomas: [],
            identity_documents: [],
            certificates: [],
            other_documents: [],
        });
    };

    onChangeRole(value) {
        this.setState({ userRole: value })
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ loading: true });
                try {

                    if (values.temporary_work_duration) {
                        values.temporary_work_duration = [
                            values.temporary_work_duration[0].format('YYYY-MM-DD'),
                            values.temporary_work_duration[1]
                                ? values.temporary_work_duration[1].format('YYYY-MM-DD')
                                : null
                        ];
                    }

                    const uploadMapping = {
                        avatar: 'avatars',
                        diploma_file: 'diplomas',
                        identity_document_file: 'identity_documents',
                        certificate_file: 'certificates',
                        other_documents: 'other_documents'
                    };

                    Object.keys(uploadMapping).forEach((field) => {
                        const stateValue = this.state[uploadMapping[field]];
                        if (stateValue && stateValue.length > 0) {
                            values[field] = stateValue;
                        }
                    });

                    if (this.props.user) {
                        await this.props.updateUser(this.props.user.id, values);
                        this.props.reloadData();
                        this.setState({ loading: false });
                    } else {
                        await this.props.createUser(values);
                        this.onClose();
                    }
                    console.log(values)
                } catch (error) {
                    this.setState({ loading: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();

        this.resetUploadState();
    }


    handleFileChange = (stateKey) => (fileList) => {
        const images = fileList.map((file) => ({
            manual_id: file.manual_id,
            src: file.originalImage,
        }));

        this.setState({ [stateKey]: images });
    };

    renderUploadField = ({
        label,
        fieldName,
        stateKey,
        multiple = true,
        maxCount = 50,
        defaultFiles = []
    }) => {
        const { getFieldDecorator } = this.props.form;

        return (
            <Form.Item label={label} className="flex-upload">
                {getFieldDecorator(fieldName, {
                    initialValue: null
                })(
                    <ImageSelector
                        onChangeData={this.handleFileChange(stateKey)}
                        multiple={multiple}
                        maxCount={maxCount}
                        uploadText="Chọn ảnh"
                        defaultFileList={defaultFiles}
                    />
                )}
            </Form.Item>
        );
    };


    render() {
        var { visible, user, config } = this.props;
        var { loading } = this.state;

        const { getFieldDecorator } = this.props.form;

        const statuses = [
            { value: 1, label: 'Active' },
            { value: 0, label: 'Inactive' },
        ];

        const insuranceStatuses = [
            { value: 1, label: 'Có đóng bảo hiểm' },
            { value: 0, label: 'Không đóng bảo hiểm' },
        ];

        const branches = config.branches || [];
        const primary_branch_ids = user?.primary_branches?.map(item => item.id) || [];
        const temporary_branch_id = user?.temporary_branch?.branch_id;

        const temporary_started_at = toMoment(
            user?.temporary_branch?.started_at
        );

        const temporary_ended_at = toMoment(
            user?.temporary_branch?.ended_at
        );

        return (
            <div>
                <Drawer
                    visible={visible}
                    title={user ? `Sửa nhân viên ${user.full_name}` : 'Thêm mới nhân viên'}
                    onClose={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '55%'}
                    footer={
                        <div style={{ textAlign: 'right' }}>
                            <Button key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Divider type="vertical" />
                            <Button key="submit" type="primary" onClick={(e) => this.submit(e)} loading={loading}>
                                {user ? 'Sửa' : 'Thêm mới'}
                            </Button>
                        </div>
                    }
                >
                    {visible ?
                        <Form layout="vertical">
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    {this.renderUploadField({
                                        label: "Avatar",
                                        fieldName: "avatar",
                                        stateKey: "avatars",
                                        multiple: false,
                                        maxCount: 1,
                                        defaultFiles: user?.avatar || []
                                    })}
                                </Col>
                                <Col xs={24} md={16}>
                                    <Row gutter={16}>
                                        <Col xs={24} md={12}>
                                            <Form.Item label="Họ tên">
                                                {getFieldDecorator('full_name', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền họ tên!',
                                                        },
                                                    ],
                                                    initialValue: user ? user.full_name : null
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item label="Username">
                                                {getFieldDecorator('username', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền username!',
                                                        },
                                                    ],
                                                    initialValue: user ? user.username : null
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item label="E-mail">
                                                {getFieldDecorator('email', {
                                                    rules: [
                                                        {
                                                            type: 'email',
                                                            message: 'Email không hợp lệ!',
                                                        },
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền E-mail!',
                                                        },
                                                    ],
                                                    initialValue: user ? user.email : null
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item label="Vai trò user">
                                                {getFieldDecorator('role_id', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng chọn vai trò!',
                                                        },
                                                    ],
                                                    initialValue: user ? user.role_id : null
                                                })(
                                                    <Select
                                                        className='w-100'
                                                        placeholder="Chọn vai trò"
                                                        onChange={(value) => this.onChangeRole(value)}
                                                        options={config.role_trees || []}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Số điện thoại">
                                        {getFieldDecorator('phone', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: 'Vui lòng điền',
                                                },
                                            ],
                                            initialValue: user ? user.phone : null
                                        })(<Input />)}
                                    </Form.Item>
                                </Col>
                                {/* Only show password input when create user */}
                                {
                                    user ? null : (
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Mật khẩu" hasFeedback>
                                                {getFieldDecorator('password', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền mật khẩu!',
                                                        },
                                                        {
                                                            validator: this.validateToNextPassword,
                                                        },
                                                    ],
                                                    initialValue: generatePassword.generate({
                                                        length: 10,
                                                        numbers: true
                                                    })
                                                })(<Input.Password autoComplete={"new-password"} className='w-100' />)}
                                            </Form.Item>
                                        </Col>
                                    )
                                }
                                <Col xs={24} md={8}>
                                    <Form.Item label="Trạng thái">
                                        {getFieldDecorator('is_active', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng chọn trạng thái!',
                                                },
                                            ],
                                            initialValue: user ? user.is_active : 1
                                        })(
                                            <BaseRadios options={statuses} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Đóng bảo hiểm">
                                        {getFieldDecorator('insurance_status', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng chọn trạng thái đóng bảo hiểm!',
                                                },
                                            ],
                                            initialValue: user && user.insurance_status != null
                                                ? user.insurance_status
                                                : 0
                                        })(
                                            <BaseRadios options={insuranceStatuses} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Cơ sở làm việc chính">
                                        {getFieldDecorator('primary_branch_ids', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng điền!',
                                                },
                                            ],
                                            initialValue: user ? primary_branch_ids ? primary_branch_ids : [] : [],
                                            normalize: value => value !== undefined ? value : null
                                        })(
                                            <BaseSelect
                                                options={branches || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                placeholder="Chọn 1 hoặc nhiều cơ sở"
                                                className="w-100"
                                                mode="multiple"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Cơ sở làm việc tạm thời">
                                        {getFieldDecorator('temporary_branch_id', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: 'Vui lòng điền',
                                                },
                                            ],
                                            initialValue: user ? temporary_branch_id ? temporary_branch_id : null : null,
                                            normalize: value => value !== undefined ? value : null
                                        })(
                                            <BaseSelect
                                                options={branches || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                placeholder="Chọn cơ sở"
                                                className="w-100"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Thời gian làm việc tạm thời">
                                        {getFieldDecorator('temporary_work_duration', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: 'Vui lòng điền',
                                                },
                                            ],
                                            initialValue: temporary_started_at
                                                ? [
                                                    moment(temporary_started_at, 'YYYY-MM-DD'),
                                                    temporary_ended_at
                                                        ? moment(temporary_ended_at, 'YYYY-MM-DD')
                                                        : null
                                                ]
                                                : null
                                        })(
                                            <RangePicker
                                                format="DD/MM/YYYY"
                                                placeholder={['Từ ngày', 'Đến ngày']}
                                                className="w-100"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn!",
                                                },
                                            ],
                                            initialValue: user ? _newLine(user.note) : null
                                        })(
                                            <Input.TextArea rows={2} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Divider orientation="left" orientationMargin="0">
                                Giấy tờ liên quan
                            </Divider>
                            <Row gutter={16}>
                                <Col xs={24} md={12}>
                                    {this.renderUploadField({
                                        label: "Bằng tốt nghiệp",
                                        fieldName: "diploma_file",
                                        stateKey: "diplomas",
                                        defaultFiles: user?.diploma_file || []
                                    })}
                                </Col>
                                <Col xs={24} md={12}>
                                    {this.renderUploadField({
                                        label: "CCCD/CMT",
                                        fieldName: "identity_document_file",
                                        stateKey: "identity_documents",
                                        defaultFiles: user?.identity_document_file || []
                                    })}
                                </Col>
                                <Col xs={24} md={12}>
                                    {this.renderUploadField({
                                        label: "Chứng chỉ hành nghề",
                                        fieldName: "certificate_file",
                                        stateKey: "certificates",
                                        defaultFiles: user?.certificate_file || []
                                    })}
                                </Col>
                                <Col xs={24} md={12}>
                                    {this.renderUploadField({
                                        label: "Giấy tờ khác",
                                        fieldName: "other_documents",
                                        stateKey: "other_documents",
                                        defaultFiles: user?.other_documents || []
                                    })}
                                </Col>
                            </Row>
                        </Form>
                        : null}
                </Drawer>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        config: state.config
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createUser: (data) => dispatch(createUser(data)),
        updateUser: (id, data) => dispatch(updateUser(id, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'UserForm' })(UserForm));
